import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
import $ from 'jquery';

class CardsServices {
	constructor() {
		this.init();
	}

	init() {
		SwiperCore.use([Navigation, Pagination]);

		var swiper_video = new Swiper('.video-module .swiper-container', {
			spaceBetween: 32,
			draggable: true,
			breakpoints: {
				150: {
					slidesPerView: 'auto'
				},
				400: {
					slidesPerView: 'auto'
				},
				580: {
					slidesPerView: 'auto'
				},
				900: {
					slidesPerView: 2
				},
				950: {
					slidesPerView: 3
				}
			},
			slidesPerView: 3,
			loop: false,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			},
		});
	}
}

export default CardsServices;
